<template>
  <b-modal
    id="period-pricing-dialog"
    ref="modal"
    :title="$t('vehicles.field_groups.period_pricing')"
    :ok-disabled="adding"
    :cancel-disabled="adding"
    :hide-header-close="adding"
    :no-close-on-backdrop="adding"
    :no-close-on-esc="adding"
    size="lg"
    centered
  >
    <b-card v-if="adding" :header="$t('general.add_new')">
      <vehicle-period-price-form
        :vehicle-id="vehicleId"
        :ride-type="rideType"
        @saved="onCreated"
        @cancelled="adding = false"
      />
    </b-card>
    <b-button
      v-if="!adding"
      variant="light"
      class="mb-2"
      @click="adding = !adding"
    >
      {{ $t('general.add_new') }}
    </b-button>
    <admin-table
      ref="table"
      :api-builder="apiBuilder"
      :columns="columns"
      :row-actions="['details', 'delete']"
      :bulk-actions="[]"
      :search-fields="null"
    >
      <template slot="period" slot-scope="{ item }">
        {{ item.period_from | moment('lll') }}
        &nbsp;&mdash;&nbsp;
        {{ item.period_to | moment('lll') }}
      </template>

      <template slot="pricing.one_way" slot-scope="{ item }">
        <value-price-with-currency :item="{priceInBaseCurrency: item.pricing.one_way}"  attribute="pricing.one_way"/>
      </template>

      <template slot="row-details" slot-scope="{ item }">
        <vehicle-period-price-form
          :vehicle-id="vehicleId"
          :id="item.id"
          :ride-type="rideType"
          @saved="onUpdated"
          @cancelled="item._showDetails = false"
        />
      </template>
    </admin-table>
  </b-modal>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import VehiclePeriodPriceForm from './Form'
import PricePeriodApi from './Api'
import ValuePriceWithCurrency from "../../components/values/ValuePriceWithCurrency";

export default {
  name: 'PeriodPricing',

  components: {
    AdminTable,
    VehiclePeriodPriceForm,
    ValuePriceWithCurrency,
  },

  props: {
    vehicleId: { type: [Number, String], required: true },
    rideType: { type: String, required: true },
  },

  data: () => ({
    adding: false,
  }),

  computed: {
    columns() {
      return [
        {
          key: 'period',
          label: this.$t('vehicles.price_periods.period'),
        },
        {
          key: 'pricing.one_way',
          label: this.$t('vehicles.attributes.pricing.one_way.label'),
        },
      ]
    },
  },

  methods: {
    apiBuilder() {
      return new PricePeriodApi(this.vehicleId, { ride_type: this.rideType })
    },
    onCreated() {
      this.adding = false
      this.$refs.table.refresh()
    },
    onUpdated() {
      this.$refs.table.refresh()
    },
  },
}
</script>
